import { Card, Modal, Stack, Text } from '@/theme/components';
import { styled } from '@/theme/index';
import { HorizontalLine } from '../../components';

export const AdjustedModal = styled(Modal)(({ theme }) => ({
  '.MuiDialog-paper': {
    maxWidth: '825px',
    overflowX: 'hidden',
    margin: theme.spacing(2.5),
  },
  '.MuiDialogContent-root': {
    padding: '0',
    overflowX: 'hidden',
    width: '825px',
    [theme.breakpoints.down('lg')]: {
      width: '825px',
    },
    [theme.breakpoints.down('md')]: {
      width: '700px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

export const ModalContent = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '0',
  margin: '0 auto',
  textAlign: 'center',
  width: '100%',
}));

export const ModalHeader = styled(Stack)(({ theme }) => ({
  borderRadius: theme.spacing(0.5, 0.5, 0, 0),
  border: 'none',
  height: '50px',
  padding: theme.spacing(0, 2),
  justifyContent: 'center',
  width: '110%',
  position: 'absolute',
  zIndex: 1,
}));

export const ModalBody = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 1.5, 1.5),
  width: '95%',
  [theme.breakpoints.up('sm')]: {
    width: '95%',
    padding: theme.spacing(0, 2.5, 1.5),
  },
  [theme.breakpoints.up('md')]: {
    width: '100%',
  },
}));

export const ModalTopSection = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  justifyContent: 'space-around',
  width: '100%',
  padding: theme.spacing(1.25),
  marginTop: theme.spacing(5),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 2.5),
    flexDirection: 'row',
  },
}));

export const DynamicDivider = styled('div')(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.grey[300]}`,
  borderLeft: 'none',
  minWidth: theme.spacing(2.5),
  width: '100%',
  minHeight: '0.8px',
  margin: theme.spacing(2, 0),
  [theme.breakpoints.up('sm')]: {
    borderLeft: `2px solid ${theme.palette.grey[300]}`,
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    borderBottom: 'none',
    minHeight: theme.spacing(2.5),
    height: '270px',
    minWidth: '0.8px',
    width: 'auto',
  },
}));

export const Subsection = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'flex-start',
  marginLeft: theme.spacing(0),
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(0),
    width: '45%',
  },
}));

export const SchoolSectionTitle = styled(Text)(({ theme }) => ({
  textAlign: 'start',
  padding: theme.spacing(0),
}));

export const AdjustedHorizontalLine = styled(HorizontalLine)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '85%',
  },
}));

export const SchoolCardElement = styled(Card)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2.5),
  alignSelf: 'center',
}));
